<div class="box card-box m-x-sm">
  <div class="box-header flex-between">
    <div class="flex flex-row">
      <h3>{{ 'PAYROLL_PREPARE.variable_payroll' | translate }}</h3>
      <div *ngIf="loading" class="m-l-1">
        <em class="fa fa-light fa-spinner fa-spin"></em>
      </div>
    </div>
    <div class="flex flex-row p-x-1" test-id="PAYROLL_PREPARE.three_payperiod_view">
      <div class="_500 m-r-1">
        <label class="ui-switch v-m">
          <input type="checkbox" [(ngModel)]="threePeriodView" (ngModelChange)="onViewModeChange()">
          <em></em>
        </label>
      </div>
      <small>{{ 'PAYROLL_PREPARE.three_payperiod_view' | translate }}</small>
    </div>
  </div>

  <div class="m-a" *ngIf="!loading && noPayPeriods">
    <gp-message text="ERROR.pay_periods_empty" type="danger"></gp-message>
  </div>

  <div class="m-a" *ngIf="!loading && isLongFuture">
    <gp-message text="ERROR.contract_begins_far_future" type="danger"></gp-message>
  </div>

  <div class="box-body" *ngIf="!noPayPeriods && !isLongFuture">
    <div *ngIf="!threePeriodView; else multiplePayperiods">
      <gp-payroll-prepare-variable-elements-single-payperiod
        [loading]="loading"
        [readOnly]="isReadOnly"
        [payPeriodsList]="payPeriodsList"
        [editedPayPeriod]="editedPayPeriod"
        [variableElements]="variableElements"
        [variableTypes]="variableInstancesRecurrenceType"
        [contract]="contract"
        [canNavigateBack]="!!previousPayPeriod?.id"
        [canNavigateForward]="!!nextPayPeriod?.id"
        [isVariablesV2Enabled]="isVariablesV2Enabled"
        (onPrevious)="navigateLeft()"
        (onNext)="navigateRight()"
        (onNavigate)="navigateTo($event)"
        (onEditElement)="editElement($event)"
        (onCreateElement)="openModal()"
        (variableElementDeletedNew)="elementDeletedNew($event)"
        (variableElementDeleted)="elementDeleted($event)"
        (isDirty)="markElementAsModified($event)">
      </gp-payroll-prepare-variable-elements-single-payperiod>
    </div>
    <ng-template #multiplePayperiods>
      <gp-payroll-prepare-variable-elements-multiple-payperiod
        *ngIf="payPeriodsList?.length"
        [loading]="loading"
        [readOnly]="isReadOnly"
        [previousPayPeriod]="previousPayPeriod"
        [editedPayPeriod]="editedPayPeriod"
        [nextPayPeriod]="nextPayPeriod"
        [variableElements]="variableElements"
        [contract]="contract"
        [canNavigateBack]="!!previousPayPeriod?.id"
        [canNavigateForward]="!!nextPayPeriod?.id"
        (onPrevious)="navigateLeft()"
        (onNext)="navigateRight()"
        (onEditElement)="editElement($event)"
        (onCreateElement)="openModal()"
        (variableElementDeletedNew)="elementDeletedNew($event)"
        (variableElementDeleted)="elementDeleted($event)"
        (isDirty)="markElementAsModified($event)">
      </gp-payroll-prepare-variable-elements-multiple-payperiod>
    </ng-template>
  </div>
</div>

<!-- Modal for editing a variable element item -->
<gp-modal gp-modal="edit-line"
          *ngIf="infoForm"
          [form]="true"
          [onSubmit]="submitEditItemModalCallback"
          [closable]="true"
          #eventpopup>
  <div class="gp-modal-title">
    {{ getTitleModal() }}
  </div>

  <div class="gp-modal-body row">
    <form [formGroup]="infoForm" role="form row">
      <div class="form-group col-md-12" *ngIf="isVariablesV2Enabled">
        <div class="form-group col-md-12">
          <label>{{ 'PAYROLL_PREPARE.recurrence_type' | translate }} </label>
          <fieldset class="recurrence-container" [disabled]="isReadOnly || (!isCreation && !editedElement?.justAdded)">
            <legend></legend>
            <div class="flex flex-row flex-1"
                 *ngFor="let recurrenceType of [
                  { transId: 'PAYROLL_PREPARE.recurrence_type_recurrent', tooltip: 'PAYROLL_PREPARE.recurring_definition' },
                  { transId: 'PAYROLL_PREPARE.recurrence_type_non_recurrent', tooltip: 'PAYROLL_PREPARE.non_recurring_definition' }
                 ]; let i=index;">
              <label class="checkbox flex align-items-center">
                <input type="radio" id="recurrence-{{i}}"
                       name="recurrenceType"
                       formControlName="recurrenceType"
                       [value]="variableRecurrence[i]"
                       (change)="onRecurrenceTypeChanged(variableRecurrence[i])">
                {{ recurrenceType.transId | translate }}
                <em class="fa fa-info-circle m-l-1" [tooltip]="recurrenceType.tooltip | translate"></em>
              </label>
            </div>
          </fieldset>
        </div>
      </div>
      <div class="form-group col-md-12">
        <div class="form-group col-md-12">
          <label>{{ 'FORMS.name' | translate }} <span>*</span></label>
          <gp-tree-select [readOnly]="isReadOnly || (!isCreation && !editedElement?.justAdded)"
                          class="form-control"
                          formControlName="name"
                          name="name"
                          [tree]="variableTypesTree"
                          test-id="newItemButton"
                          [placeholder]="'PAYROLL_PREPARE.add_new_item' | translate"
                          ngDefaultControl
                          (elementSelected)="onVariableTypeChanged($event.id)">
          </gp-tree-select>
        </div>
      </div>

      <div class="form-group col-md-12" *ngIf="infoForm.get('name')?.value">
        <div class="form-group col-md-6 flex flex-column">
          <label>{{ 'FORMS.begin_date' | translate }} <span>*</span></label>
          <datepicker-input #begindate
                            *ngIf="!infoForm.get('isBeginDateLinkedToContract').value; else begindateLabel"
                            id="beginDate"
                            name="begindate"
                            [(ngModel)]="editedElement.attributes.userbegindate"
                            [minDate]="minDate"
                            [hasEternity]="true"
                            (ngModelChange)="onChangeDates()"
                            formControlName="beginDate"
                            [readOnly]="isReadOnly"
                            ngDefaultControl
                            test-id="modalBeginDate"
                            (keyup)="onChangeDates()">
          </datepicker-input>
          <ng-template #begindateLabel>
            <label class="date-label">
              {{ getContractBeginDate() | gpDate }}
            </label>
          </ng-template>
          <label class="flex" *ngIf="isVariablesV2Enabled">
            <input type="checkbox" formControlName="isBeginDateLinkedToContract"
                   [checked]="editedElement?.attributes.isBeginDateLinkedToContract"
                   (change)="onBeginDateLinkedToContractChange($event)">
            <p class="text-xs m-l-sm m-b-0"
               [class.text-muted]="infoForm.get('isBeginDateLinkedToContract').value || isReadOnly">
              {{ 'PAYROLL_PREPARE.linked_to_contract_begindate' | translate }}
            </p>
          </label>
        </div>

        <div class="form-group col-md-6 flex flex-column">
          <label>{{ 'FORMS.end_date' | translate }}</label>
          <datepicker-input #enddate
                            *ngIf="!infoForm.get('isEndDateLinkedToContract').value; else enddateLabel"
                            id="endDate"
                            name="enddate"
                            formControlName="endDate"
                            [readOnly]="isReadOnly"
                            [(ngModel)]="editedElement.attributes.userenddate"
                            [hasEternity]="true"
                            [minDate]="minDate"
                            (ngModelChange)="onChangeDates()"
                            ngDefaultControl
                            test-id="modalEndDate"
                            (keyup)="onChangeDates()">
          </datepicker-input>
          <ng-template #enddateLabel>
            <label class="date-label">
              {{ getContractEndDate() | gpDate }}
            </label>
          </ng-template>
          <label class="flex" *ngIf="isVariablesV2Enabled">
            <input type="checkbox" formControlName="isEndDateLinkedToContract"
                   [checked]="editedElement?.attributes.isEndDateLinkedToContract"
                   (change)="onEndDateLinkedToContractChange($event)">
            <p class="text-xs m-l-sm m-b-0"
               [class.text-muted]="infoForm.get('isEndDateLinkedToContract').value || isReadOnly">
              {{ 'PAYROLL_PREPARE.linked_to_contract_enddate' | translate }}
            </p>
          </label>
        </div>

        <ul class="error-list begin-before-end form-group col-md-12"
            *ngIf="!isBeginBeforeEnd && infoForm.valid && getDatePickerValid()">
          <li>{{ 'FORMS.VALIDATORS.end_date_earlier_start_date' | translate }}</li>
        </ul>

        <div class="form-group col-md-12">
          <label>{{ editedElement.attributes.unitTransId | translate }} <span>*</span></label>
          <div>
            <number-input [type]="'decimal'"
                          name="value"
                          formControlName="prepValue"
                          [(ngModel)]="evAmount"
                          [validOnPristine]="false"
                          [readOnly]="isReadOnly"
                          required
                          test-id="modalValue"
                          ngDefaultControl
                          [maxDigits]="4">
            </number-input>
          </div>
        </div>

        <div class="form-group col-md-12">
          <label>{{ 'Comment' | translate }}</label>
          <div>
            <textarea class="form-control"
                      name="comment"
                      rows="5"
                      formControlName="comment"
                      [(ngModel)]="editedElement.attributes.comment"
                      [readOnly]="isReadOnly"
                      title="{{'Comment' | translate}}">
            </textarea>
          </div>
        </div>

        <gp-variable-zones
          [contractId]="contract.id"
          [cliRegId]="cliRegId"
          [data]="editedElement"
          [name]="editedElement.attributes.name"
          [readOnly]="isReadOnly"
          (formLoaded)="formVariableZoneLoaded()">
        </gp-variable-zones>
      </div>
    </form>
  </div>

  <div class="gp-modal-footer flex align-items-center" [class.flex-between]="variableOutsideContract"
       [class.flex-end]="!variableOutsideContract">
    <div *ngIf="variableOutsideContract" class="text-danger">
      {{ 'PAYROLL_PREPARE.variable_outside_contract_limits' | translate }}
    </div>
    <div class="btn-bar-wrapper">
      <div class="btn-bar btn-bar-sm btn-bar-align-end">
        <button type="button"
                class="btn btn-dark p-x-md"
                *ngIf="!isReadOnly && !isConfirmButtonVisible"
                (click)="submitForm(eventpopup)"
                [disabled]="!isFormValid()"
                test-id="modalSubmitButton">
          {{ 'FORMS.submit' | translate }}
        </button>
        <button type="button"
                class="btn btn-warning p-x-md"
                *ngIf="!isReadOnly && isConfirmButtonVisible"
                (click)="confirmSubmission(eventpopup)"
                [disabled]="!isFormValid()"
                test-id="modalConfirmButton">
          {{ 'FORMS.confirm' | translate }}
        </button>
        <button type="button"
                class="btn btn-secondary p-x-md"
                (click)="cancelEditItemModalCallback()"
                test-id="modalCancelButton">
          {{ isReadOnly ? ('FORMS.enclose' | translate) : ('FORMS.cancel' | translate) }}
        </button>
      </div>
    </div>

  </div>
</gp-modal>
